const api = 'https://fastapi-crud.herokuapp.com/recipe/';

export default api;